var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-chat__userImage",class:{ '-small': _vm.small, '-medium': _vm.medium, '-large': _vm.large }},[_c('img',{attrs:{"src":_vm.user.avatar_url,"alt":_vm.user.displayName}}),_c(_setup.StatusIndicator,{attrs:{"small":_vm.small,"medium":_vm.medium,"large":_vm.large,"status":_vm.user.isOnline}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }